export const iconFontAwesomeHumanitarianPersonDress = (
	<i className="fa-solid fa-person-dress"></i>
);
